<template>
  <PriceRescueConfirmationDialog
    v-if="confirmation.active"
    body-class="admin-dialog-body"
    cancel-button-class="admin-btn"
    danger-confirm-button-class="admin-btn admin-btn-danger"
    dialog-class="admin-dialog"
    field-class="admin-field"
    footer-class="admin-actions"
    header-class="admin-dialog-title"
    input-class="admin-input"
    overlay-class="admin-dialog-shell"
    cancel-label="Cancel"
    :confirm-label="confirmation.active.confirmLabel ?? 'Confirm'"
    :message="confirmation.active.message"
    :open="confirmation.active !== undefined"
    :require-typed-text="confirmation.active.typedConfirmation"
    :title="confirmation.active.title"
    tone="danger"
    @cancel="confirmation.resolve(false)"
    @confirm="confirmation.resolve(true)"
  />
</template>

<script setup lang="ts">
import { PriceRescueConfirmationDialog } from "@price-rescue/ui-components";

import { useAdminConfirmationStore } from "../features/shared-ui/confirmation-store.js";

const confirmation = useAdminConfirmationStore();
</script>

<style scoped>
:global(.admin-dialog-shell) {
  position: fixed;
  z-index: 100;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(15, 23, 42, 0.48);
}

:global(.admin-dialog) {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 14px;
  width: min(520px, calc(100vw - 32px));
  border-radius: 22px;
  padding: 22px;
  background: white;
  color: #172033;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.26);
}

:global(.admin-dialog-title) {
  font-size: 1.35rem;
  font-weight: 800;
}
</style>
